import React from 'react'
import NotificationProvider from './context'
import { TAppProps } from './context/types'
import NotificationMain from './components/NotificationMain'

export function openNotification() {
    if (typeof window === 'undefined') {
        return
    }
    const event = new CustomEvent('VNW_OPEN_NOTIFICATION')
    window.dispatchEvent(event)
}

const Notifications = (props: TAppProps) => {
    return (
        <NotificationProvider {...props}>
            <NotificationMain />
        </NotificationProvider>
    )
}

export default React.memo(Notifications, (prevProps, nextProps) => {
    // User logged in or User logged out
    if (
        (typeof prevProps.user === null && typeof nextProps.user !== null) ||
        (typeof prevProps.user !== null && typeof nextProps.user === null)
    ) {
        return false
    }
    // userId match then don't need to render
    return prevProps.user?.userId === nextProps.user?.userId
})
